import React, { createContext, useCallback, useContext, useState } from 'react';
import ProjectModal from './ProjectModal';

const ProjectModalContext = createContext({ open: () => {}, close: () => {} });

export const useProjectModal = () => useContext(ProjectModalContext);

export const ProjectModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <ProjectModalContext.Provider value={{ open, close }}>
      {children}
      <ProjectModal isOpen={isOpen} onClose={close} />
    </ProjectModalContext.Provider>
  );
};
